import { useContext } from 'react';

import { FormContext } from '../FormContext';

export function useClientForm() {
  return useContext(FormContext);
}
